import { Container, Row, Col, Button, Form } from 'react-bootstrap';
import { useEffect, useRef, useState } from 'react';
import '../../../App.css';
import '../../../css/bootstrap.scss';
import phoneno_icon from "../../../images/phone_no.png";
import { Link } from 'react-router-dom';
import Header from '../../Includes/Header';
import BackButton from '../../Includes/BackButton';
import axios, { AxiosError } from 'axios';
import { Field, reduxForm, InjectedFormProps } from 'redux-form';
import { connect } from 'react-redux';
import { setEmail, setEmailVerify, setwizardPageNumber, setphoneNo, setUserID } from '../../authslice';
import { RootState } from '../../store';
import { useDispatch, useSelector } from 'react-redux';
import config from '../../../config';
import { ToastBox, notifyError, notifySuccess } from 'MyComponents/Toaster';
import Spacer from 'MyComponents/UI/Spacer';
import { updatePersonalKycDraftStep } from 'Utils/personalKycDraft';
import { getUserID } from 'Utils/user';
import { useTranslation } from 'react-i18next';

interface Props {}

interface FormData {
    phoneNo: string;
    otpCode: string;
}

const PhonenoVerification: React.FC<Props & InjectedFormProps<{}, Props, FormData>> = (props: any) => {
    const { t } = useTranslation();
    const { handleSubmit } = props;
    const dispatch = useDispatch();
    const email = useSelector((state: RootState) => state.auth.email);
    const userID = useSelector((state: RootState) => state.auth.userID);
    const phoneNo = useSelector((state: RootState) => state.auth.phoneNo);
    const countrySelected = useSelector((state: RootState) => state.auth.selectedCountryName);
    const page = useSelector((state: RootState) => state.auth.wizardPageNumber);

    const [validated, setValidated] = useState(false);
    const sendotp_baseURL = config.NODE_API_BASE_URL + '/twillio/sendSMSOTP';
    const verifyotp_baseURL = config.NODE_API_BASE_URL + '/twillio/verifySMSOTP';
    const savePhoneNo_baseURL = config.NODE_API_BASE_URL + '/wso2/savePhoneNo';

    const num1 = useRef<HTMLInputElement>(null);
    const num2 = useRef<HTMLInputElement>(null);
    const num3 = useRef<HTMLInputElement>(null);
    const num4 = useRef<HTMLInputElement>(null);
    const num5 = useRef<HTMLInputElement>(null);
    const num6 = useRef<HTMLInputElement>(null);

    const sendOTP = async (resend: number) => {
        try {
            const sendOTPResponse = await axios.post(sendotp_baseURL, {
                phoneNo: phoneNo,
                country: countrySelected
            }).catch((reason: AxiosError<{ additionalInfo: string }>) => {
                if (reason.response?.status === 404) {
                    notifyError('OTP Failed');
                } else if (reason.response?.status === 429) {
                    notifyError('Something Went Wrong');
                } else {
                    notifyError('Something Went Wrong');
                }
            });

            if (resend === 1) {
                notifySuccess("OTP Sent");
            }
            return sendOTPResponse?.data;
        } catch (error) {
            console.error(error);
        }
    };

    const handleOtpInput = (e: React.ChangeEvent<HTMLInputElement>, nextInputRef: React.RefObject<HTMLInputElement> | null) => {
        const input = e.target;
        const value = input.value;

        if (value.length === 1 && /^\d$/.test(value)) {
            if (nextInputRef && nextInputRef.current) {
                nextInputRef.current.focus();
            }
        } else {
            input.value = '';
        }
    };

    const fieldsEmpty = () => {
        num1.current!.value = "";
        num2.current!.value = "";
        num3.current!.value = "";
        num4.current!.value = "";
        num5.current!.value = "";
        num6.current!.value = "";
    };

    const verifyOTP = async (phoneNo: string, otpCode: string) => {
        try {
            const verifyOTPResponse = await axios.post(verifyotp_baseURL, {
                phoneNo: phoneNo,
                otpCode: otpCode,
                country: countrySelected
            }).catch((reason: AxiosError<{ additionalInfo: string }>) => {
                if (reason.response?.status === 404) {
                    notifyError('Invalid OTP');
                } else if (reason.response?.status === 429) {
                    notifyError('Something Went Wrong');
                } else {
                    notifyError('Something Went Wrong');
                }
                fieldsEmpty();
                return;
            });
            return verifyOTPResponse?.data;
        } catch (error) {
            console.error(error);
            fieldsEmpty();
        }
    };

    const submitForm = async () => {
        const userEnteredOtp = `${num1.current?.value}${num2.current?.value || ''}${num3.current?.value || ''}${num4.current?.value || ''}${num5.current?.value || ''}${num6.current?.value || ''}`;

        if (userEnteredOtp === '') {
            notifyError("Invalid OTP.");
            return;
        }

        const response = await verifyOTP(phoneNo, userEnteredOtp);
        if (response?.status === "approved") {
            dispatch(setphoneNo(phoneNo));

            const currentUserID = props.userID || userID;
            if (currentUserID) {
                updatePersonalKycDraftStep(currentUserID, 'phoneVerification', { verified: true, phoneNo });
                updatePersonalKycDraftStep(currentUserID, 'wizardState', { pageNumber: page + 1 });
            }

            dispatch(setwizardPageNumber(page + 1));
            localStorage.setItem('pageNumber', `${page + 1}`);
        } else {
            notifyError("Invalid OTP.");
        }
    };

    const changePhoneNo = () => {
        dispatch(setwizardPageNumber(page - 1));
        localStorage.setItem('pageNumber', `${page - 1}`);
    };

    return (
        <>
            <ToastBox />
            <Container fluid className="px-0 px-md-3">
                <Row className="g-0">
                    <Col md={12} className="mx-auto px-2 pt-0 pb-3">
                        <div className="mt-5">
                            <Row className="px-2 px-md-5">
                                <Col md={12}><BackButton /></Col>
                            </Row>
                            <Row className="px-2 px-md-5 mt-4">
                                <Col md={12} className="text-center">
                                    <img src={phoneno_icon} width={50} alt="Phone Icon" />
                                    <h3 className="text-center mt-3">{t('kyc.verify_phone_title')}</h3>
                                    <span className="fw-normal">
                                        {t('kyc.code_sent')}
                                        <br />
                                        <span className="fw-bold">{phoneNo}</span>. {t('kyc.code_valid')}{' '}
                                        <Link className="text-primary" to="" onClick={changePhoneNo}>
                                            {t('kyc.change_mobile')}
                                        </Link>
                                    </span>
                                    <p className="fs-5 mt-3 letter-spacing-fix">{t('login.enter_code')}</p>

                                    <Form noValidate={true} onSubmit={handleSubmit(submitForm)}>
                                        <div className="input-group d-flex justify-content-center">
                                            <input type="number" onInput={(e: React.ChangeEvent<HTMLInputElement>) => handleOtpInput(e, num2)} ref={num1} className="rounded-4 border border-1 otp-input" />
                                            <input type="number" onInput={(e: React.ChangeEvent<HTMLInputElement>) => handleOtpInput(e, num3)} ref={num2} className="ms-2 rounded-4 border border-1 otp-input" />
                                            <input type="number" onInput={(e: React.ChangeEvent<HTMLInputElement>) => handleOtpInput(e, num4)} ref={num3} className="ms-2 rounded-4 border border-1 otp-input" />
                                            <input type="number" onInput={(e: React.ChangeEvent<HTMLInputElement>) => handleOtpInput(e, num5)} ref={num4} className="ms-2 rounded-4 border border-1 otp-input" />
                                            <input type="number" onInput={(e: React.ChangeEvent<HTMLInputElement>) => handleOtpInput(e, num6)} ref={num5} className="ms-2 rounded-4 border border-1 otp-input" />
                                            <input type="number" onInput={(e: React.ChangeEvent<HTMLInputElement>) => handleOtpInput(e, null)} ref={num6} className="ms-2 rounded-4 border border-1 otp-input" />
                                        </div>
                                        <div className="d-grid gap-2 col-md-3 mx-auto mt-4">
                                            <Button type="submit" className="btn btn-primary mt-3 rounded-5">
                                                {t('common.submit')}
                                            </Button>
                                        </div>
                                    </Form>

                                    <div className="mt-3">
                                        <span>
                                            {t('common.didnt_receive')}{' '}
                                            <Link className="text-primary" to="" onClick={() => sendOTP(1)}>
                                                {t('common.resend_code')}
                                            </Link>
                                        </span>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

const form = reduxForm<{}, Props, FormData>({
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    form: 'wizard',
    enableReinitialize: true,
})(PhonenoVerification);

export default connect(null)(form);
